import {
  getCopyWithContentTableColumn,
  getTimeTableColumn,
} from '@/utils/common/tableColumn.js'

export default {
  created () {
    this.columns = [
      getCopyWithContentTableColumn({
        field: 'licensee',
        title: '公司名称',
      }),
      // getCopyWithContentTableColumn(),
      {
        field: 'service_num',
        title: '服务器识别码',
        minWidth: 300,
        showOverflow: 'title',
        slots: {
          default: ({ row }, h) => {
            return [
              h('div', row.service_num.split(',').map(item => {
                return h('a-tag', {
                  class: 'text-truncate mt-1 mb-1',
                  style: {
                    display: 'block',
                  },
                  props: {
                    size: 'mini',
                    type: 'info',
                  },
                }, item)
              })),
            ]
          },
        },
      },
      {
        field: 'used_for',
        title: 'License类型',
        minWidth: 100,
        formatter: ({ cellValue }) => {
          const map = {
            test: '试用',
            community: '测试',
            community_zjydjc: '测试',
            internal: '云联壹云内部使用版',
            commercial: '云联壹云商用版',
          }
          return map[cellValue]
        },
      },
      {
        field: 'status',
        title: '有效状态',
        sortable: true,
        minWidth: 100,
        slots: {
          default: ({ row }) => {
            const status = this.$moment().isAfter(row.expire) ? 'failure' : 'effective'
            const statusObj = {
              effective: '有效',
              failure: '失效',
            }
            const statusClass = {
              effective: 'status-success',
              failure: 'status-danger',
            }
            return [
              <div class='text-truncate' class={ statusClass[status] }>{ statusObj[status] }</div>,
            ]
          },
        },
      },
      getTimeTableColumn({ sortable: true }),
      getTimeTableColumn({
        field: 'expire',
        title: '失效时间',
      }),
    ]
  },
}
